module.exports = __webpack_public_path__ + "static/filter-f2d7e9206a621ce1be5f35d78483e3a4.svg";